import { StateContext } from '@ngxs/store';
import { reduce as _reduce } from 'lodash-es';

/**
 * Creates entities and collection ids and patch state
 *
 * @param ctx - state context
 * @param payload - array of the entities
 * @param shouldBeStateReset - should the state be updated (shouldBeStateReset = false) or rewritten (shouldBeStateReset = true)
 */
export function patchSearchIdsAndEntities(ctx: StateContext<any>, payload: any[], shouldBeStateReset = true, idFieldName = 'id') {
  let initialValue;

  if (shouldBeStateReset) {
    initialValue = { entities: ctx.getState().entities, searchResultIds: [] };
  } else {
    const { entities, searchResultIds } = ctx.getState();
    initialValue = { entities, searchResultIds };
  }

  const res = _reduce(
    payload,
    (acc, entity) => ({
      entities: {
        ...acc.entities,
        [entity[idFieldName]]: {
          ...acc.entities[entity[idFieldName]],
          ...entity,
        },
      },
      searchResultIds: acc.searchResultIds.indexOf(entity[idFieldName]) === -1 && acc.searchResultIds.indexOf(initialValue.entities[idFieldName]) === -1 ? [...acc.searchResultIds, entity[idFieldName]] : acc.searchResultIds,
    }),
    initialValue,
  );

  return ctx.patchState(res);
}
